// extracted by mini-css-extract-plugin
export var link = "hm_R";